// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"down-arrow-module--wrapper--fe8V8"};